export const getQueryParams = () => {
  return new URLSearchParams(window.location.search);
};
